import React from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

const overrideOptions = [
  { slug: 5, value: '5 - Tight' },
  { slug: 4, value: '4 - Tight' },
  { slug: 3, value: '3 - Tight' },
  { slug: 2, value: '2 - Tight' },
  { slug: 1, value: '1 - Tight' },
  { slug: 0, value: '0 - Neutral' },
  { slug: -1, value: '1 - Loose' },
  { slug: -2, value: '2 - Loose' },
  { slug: -3, value: '3 - Loose' },
  { slug: -4, value: '4 - Loose' },
  { slug: -5, value: '5 - Loose' },
];

const minValue = -120;
const degreeCharacter = '\u00B0';
const trackDriveabilityOverrideOptions = _.times(25, (i) => {
  const val = minValue + i * 10;
  return { slug: val, value: `${val}${degreeCharacter}` };
});

/**
 * Used when evaluating overall cornering instead of breaking down by each corner individually
*/
export default class SectionCornerOverall extends React.Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.cornerTypes = [
      { slug: 'entry', label: '1) Entry', description: 'Describe corner entry', overrideOptions },
      { slug: 'center', label: '2) Center', description: 'Describe center turn', overrideOptions },
      { slug: 'exit', label: '3) Exit', description: 'Describe corner exit', overrideOptions },
      { slug: 'wheelInIt', label: '4) Wheel Input', description: 'Describe max wheel input needed at mid corner', overrideOptions: trackDriveabilityOverrideOptions, overrideDefaultValue: 12 },
    ];

    this.renderCornerFields = this.renderCornerFields.bind(this);
  }

  renderCornerFields() {
    return this.cornerTypes.map(type => (
      <Col xs={12} sm={6} key={type.slug}>
        <FieldTextAreaWithRating
          label={type.label}
          description={type.description}
          ratingField={`corners.0.${type.slug}.rating`}
          textAreaField={`corners.0.${type.slug}.feedback`}
          placeholder="Feedback"
          overrideOptions={type.overrideOptions}
          overrideDefaultValue={_.get(type, 'overrideDefaultValue', 0)}
        />
      </Col>
    ));
  }

  render() {
    return (
      <Row>
        {this.renderCornerFields()}
      </Row>
    );
  }
}
